import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  Box
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface VehicleUpdateModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  vehicleNumber: string;
  onVehicleNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  vehicleError: string;
  currentVehicle?: string;
}

const VehicleUpdateModal: React.FC<VehicleUpdateModalProps> = ({
  open,
  onClose,
  onSave,
  vehicleNumber,
  onVehicleNumberChange,
  vehicleError,
  currentVehicle
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '5px',
        backgroundColor: 'white',
        boxShadow: 1,
        fontWeight: 'bold'
      }}>
        {currentVehicle ? 'Update Vehicle' : 'Add Vehicle'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{padding:'0px'}}>
        <Box sx={{marginTop:'10px'}}>
          <TextField 
            type="text" 
            placeholder="Enter Vehicle Number"
            label="Enter Vehicle Number"
            value={vehicleNumber || currentVehicle || ''}
            onInput={(e: any) => onVehicleNumberChange(e)}

            error={!!vehicleError}
            helperText={vehicleError}
            style={{ padding: '8px', fontSize: '16px' }} 
            fullWidth
            inputProps={{
              autoCorrect: "off",
              autoCapitalize: "off",
              spellCheck: "false",
              inputMode: "text",
              autoComplete: "off"
              }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{justifyContent:'center', display:"flex"}}>
        <Button onClick={onClose} sx={{border: '1px solid rgb(248, 18, 18)', color:'red'}}>Cancel</Button>
        <Button 
          variant="contained"
          sx={{backgroundColor:'green'}}
          onClick={onSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VehicleUpdateModal;